import * as $ from 'jquery'
import './site_common'

import 'Components/basics/breadcrumb/component'

import 'Components/site/subsidies/go_to_top/component'
import 'Components/site/subsidies/heading/component'
import 'Components/site/subsidies/heading_from_brackets_to_underline/component'
import 'Components/site/subsidies/accordion_content_with_heading/component'
import 'Components/site/subsidies/terms_section/component'
import 'Components/site/subsidies/receiving_flow_section/component'
import 'Components/site/subsidies/search_by_prefectures/component'
import 'Components/site/subsidies/search_by_construction_type/component'
import 'Components/site/subsidies/side_search_widget/component'
import 'Components/site/subsidies/summary_card/component'
import 'Components/site/subsidies/search_result_view/component'
import 'Components/site/subsidies/search_result_view_more_button/component'
import 'Components/site/subsidies/top_search_widget/component'
import 'PackWerkNurikaeSite/pages/subsidies/partials/floating_cta/pc/component'
import 'PackWerkNurikaeSite/pages/subsidies/partials/floating_cta/sp/component'

import { setViewHeight } from '../src/subsidies/components/setViewHeight'
import { changeCompleteStatusForSelect } from '../src/subsidies/components/changeCompleteStatusForSelect'

window.$ = $

$(() => {
  // スマホのメニューバーを考慮したvhを利用するために実行
  setViewHeight()
  window.addEventListener('resize', setViewHeight)

  // セレクトタグ用のプレースホルダー処理
  changeCompleteStatusForSelect()
})
